/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Email({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2 1.9A1.6 1.6 0 0 0 .4 3.5v9A1.6 1.6 0 0 0 2 14.1h12a1.6 1.6 0 0 0 1.6-1.6v-9A1.6 1.6 0 0 0 14 1.9H2Zm-.358 1.422A.4.4 0 0 1 2 3.1h12a.4.4 0 0 1 .358.222L9.806 8.525a2.4 2.4 0 0 1-3.612 0L1.642 3.322ZM1.6 5.097v5.455l2.546-2.546L1.6 5.096Zm0 7.151v.252c0 .22.18.4.4.4h12a.4.4 0 0 0 .4-.4v-.252l-3.337-3.337-.354.404a3.6 3.6 0 0 1-5.418 0l-.354-.404L1.6 12.25Zm12.8-1.696V5.097l-2.546 2.909 2.546 2.546Z" clipRule="evenodd" /></svg>;
}
;